import IconButton from '@zenbusiness/zui/IconButton';
import { styled } from '@zenbusiness/zui/styles';
import Tooltip, { tooltipClasses } from '@zenbusiness/zui/Tooltip';

const TooltipStyle = ({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    ...theme.typography.xs,
    height: '32px',
    padding: '8px 14px',
    borderRadius: '12px',
    backgroundColor: theme.palette.fixed.black
  }
});

const IconButtonStyle = ({ theme }) => ({
  width: '30px',
  height: '30px',
  borderRadius: '50%',
  padding: '2px',
  '&:hover': {
    backgroundColor: theme.palette.background.grey.darker
  }
});

export const IconButtonStyled = styled(IconButton)(IconButtonStyle);
export const TooltipStyled = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    aria-label="copy button"
    classes={{ popper: className }}
  />
))(TooltipStyle);
